export const columns = [
  {
    accessorKey: "sNo",
    header: "Serial #",
    flex: 1,
  },
  {
    accessorKey: "typeOfCargo",
    header: "Cargo",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "daily",
    header: "Daily",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.daily || 0}`,
  },
  {
    accessorKey: "monthly",
    header: "Monthly",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.monthly || 0}`,
  },
  {
    accessorKey: "yearly",
    header: "Yearly",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.yearly || 0}`,
  },
];
